export interface ICustomNodeObject {
  startIndex: number;
  endIndex: number;
  node: Node;
}

export interface ITopLevelCustomNodeObject {
  customNodesObjectArray: ICustomNodeObject[];
  globalNodeStartIndex: { value: number };
  totalCharactersProcessedCount: number;
  totalNodesProcessedCount: number;
  currentReplacementObjectIndex: number;
  originalText: string;
  modifiedText: string;
  topLevelParagraphNode: Node;
}

export interface ParaphraseGrammarCheckData {
  grammarCheckText: string;
}

export enum GcSettingNames {
  GC_FLUENCY_MODE = 'gcFluencyModeEnabled',
  GC_REGIONAL_LANGUAGE = 'gcRegionalLanguage',
}
